// Configurações para integração com Google Maps
export const MAPS_CONFIG = {
  // Chave da API do Google Maps Embed
  // ⚠️ IMPORTANTE: Configure a variável de ambiente REACT_APP_GOOGLE_MAPS_API_KEY
  GOOGLE_MAPS_API_KEY: 'AIzaSyBfpiS01VZj4TN_DQttt2J_ikpfF1SdPeY',
  
  // URLs base para diferentes funcionalidades
  BASE_URLS: {
    SEARCH: 'https://www.google.com/maps/search',
    DIRECTIONS: 'https://www.google.com/maps/dir',
    EMBED: 'https://www.google.com/maps/embed/v1/place'
  },
  
  // Configurações do mapa embutido
  EMBED_CONFIG: {
    width: '100%',
    height: '100%',
    style: { border: 0 },
    allowFullScreen: true,
    loading: 'lazy' as const,
    referrerPolicy: 'no-referrer-when-downgrade' as const
  }
};

// Função para gerar URL de busca no Google Maps
export const getGoogleMapsSearchUrl = (address: string, city: string = '') => {
  const fullAddress = `${address}, ${city}`.trim();
  return `${MAPS_CONFIG.BASE_URLS.SEARCH}/${encodeURIComponent(fullAddress)}`;
};

// Função para gerar URL de navegação no Google Maps
export const getGoogleMapsDirectionsUrl = (address: string, city: string = '') => {
  const fullAddress = `${address}, ${city}`.trim();
  return `${MAPS_CONFIG.BASE_URLS.DIRECTIONS}//${encodeURIComponent(fullAddress)}`;
};

// Função para gerar URL do iframe do Google Maps
export const getGoogleMapsEmbedUrl = (address: string, city: string = '') => {
  const fullAddress = `${address}, ${city}`.trim();
  return `${MAPS_CONFIG.BASE_URLS.EMBED}?key=${MAPS_CONFIG.GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent(fullAddress)}`;
};
